import LoginPage from './globals';

export default({
    translation:
        Object.assign(
            LoginPage,
        )
    })